import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { LoadMore } from './../../ui/src/component/loadMore';
import { StandardArticle } from './../../ui/src/component/article';
import Api from './../../ui/src/api';
import { getProp } from './../../ui/src/utilities';

import { Helmet } from 'react-helmet';

class SearchResults extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      articles: [],
      nextOffset: null,
      isFetching: false,
    };
  }

  componentDidMount() {
    const query = this.getQueryString(this.props);
    this.fetchResults(query);
  }

  componentWillReceiveProps(nextProps) {
    let query = this.getQueryString(this.props);
    let newQuery = this.getQueryString(nextProps);
    if (query !== newQuery) {
      this.fetchResults(newQuery);
    }
  }

  fetchResults(query, offset = 0, limit = 20) {
    this.setState({ isFetching: true });
    Api.get(
      `/cm/public/${
        process.env.REACT_APP_CONTENT_SPACE
      }/articles?q=${query}&offset=${offset}&limit=${limit}`,
    ).then(
      response => {
        if (offset === 0) {
          this.setState({
            articles: response.articles,
            nextOffset: response.nextOffset,
          });
        } else {
          this.setState({
            articles: [...this.state.articles, ...response.articles],
            nextOffset: response.nextOffset,
          });
        }
        this.setState({ isFetching: false });
      },
      error => {
        console.error(error);
      },
    );
  }

  getQueryString(props) {
    return getProp(props, 'location.query.q', '');
  }

  onLoadMore() {
    this.fetchResults(this.getQueryString(this.props), this.state.nextOffset);
  }

  render() {
    let queryString = this.getQueryString(this.props);

    return (
      <div>
        <Helmet>
          <title>{`Výsledky vyhľadávania "${queryString}"`}</title>
        </Helmet>

        <div className="bg-alt-light article-header">
          <div className="container">
            <div className="article-header-title">
              <h1>Výsledky vyhľadávania "{queryString}"</h1>
            </div>
          </div>
        </div>

        {this.state.articles.length === 0 && !this.state.isFetching ? (
          <div className="">
            <div className="text-center" style={{ padding: '150px 0' }}>
              <h1>Ľutujeme, nič sme nenašli</h1>
              <Link to="/" className="btn btn-primary btn-lg">
                Prejsť na hlavnú stránku
              </Link>
            </div>
          </div>
        ) : (
          <div className="container section">
            <div className="row">
              {this.state.articles.map(item => {
                return (
                  <div key={item._id} className="col-xs-12 col-sm-4 col-md-3">
                    <StandardArticle article={item} />
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {this.state.nextOffset !== null ? (
          <div className="text-center section">
            <LoadMore
              show={!this.state.isFetching && this.state.nextOffset !== null}
              onClick={this.onLoadMore.bind(this)}
            />
          </div>
        ) : null}
      </div>
    );
  }
}

SearchResults.propTypes = {
  dispatch: PropTypes.func.isRequired,
  params: PropTypes.object.isRequired,
};

export default connect(state => {
  return {};
})(SearchResults);



// WEBPACK FOOTER //
// ./src/app/container/searchResults.js